<template>
  <div>
    <div>
      <b-form inline @submit="onSubmit">
        <b-form-group label="Baseline 1:"
                      description="Select the first baseline you'd like to compare"
                      label-for="baseline-1">
          <b-form-select id="baseline-1"
                         v-model="selectedBaselinesLite.baselineOne"
                         :options="baselinesArray"
                         required>
          </b-form-select>
        </b-form-group>
        <b-form-group label="Baseline 2:"
                      description="Select the second baseline you'd like to compare"
                      label-for="baseline-2">
          <b-form-select id="baseline-2"
                         v-model="selectedBaselinesLite.baselineTwo"
                         :options="baselinesArray"
                         required>
          </b-form-select>
        </b-form-group>
        <b-button type="submit"
                  variant="primary"
                  :disabled="!selectedBaselinesLite.baselineOne || !selectedBaselinesLite.baselineTwo || loading">
          <span v-if="loading"><icon name="spinner" pulse></icon> Comparing</span>
          <span v-else>Compare</span>
        </b-button>
      </b-form>
    </div>
    <table class="rm-table" v-if="hasResults && requirementTypeLookupReady">
      <thead>
      <tr>
        <th id="id">Requirement ID</th>
        <th id="name">Field</th>
        <th id="baseline-one">Baseline 1</th>
        <th id="baseline-two">Baseline 2</th>
      </tr>
      </thead>
      <tbody v-for="requirement in Array.from(diffLookup)">
      <tr>
        <td headers="id">
          <a href="#" @click="goToReq(requirement[0])">{{ getDisplayID(requirement[0]) }}</a>
        </td>
        <td headers="field">
        </td>
        <td headers="baseline-one">
        </td>
        <td headers="baseline-two">
        </td>
      </tr>
      <tr v-if="requirement[1].has('name')">
        <td headers="id">
        </td>
        <td headers="field">
          Name
        </td>
        <td headers="baseline-one">
          <span v-if="requirement[1].get('name').baselineOne">{{ requirement[1].get('name').baselineOne }}</span>
        </td>
        <td headers="baseline-two">
          <span v-if="requirement[1].get('name').baselineTwo">{{ requirement[1].get('name').baselineTwo }}</span>
        </td>
      </tr>
      <tr v-if="requirement[1].has('requirement_type_id')">
        <td headers="id">
        </td>
        <td headers="field">
          Type
        </td>
        <td headers="baseline-one">
          <span v-if="requirement[1].get('requirement_type_id').baselineOne">
            {{ requirementTypeLookup[requirement[1].get('requirement_type_id').baselineOne].name }} requirement
          </span>
        </td>
        <td headers="baseline-two">
          <span v-if="requirement[1].get('requirement_type_id').baselineTwo">
            {{ requirementTypeLookup[requirement[1].get('requirement_type_id').baselineTwo].name }} requirement
          </span>
        </td>
      </tr>
      <tr v-if="requirement[1].has('assigned_to')">
        <td headers="id">
        </td>
        <td headers="field">
          Assignee
        </td>
        <td headers="baseline-one">
          <span v-if="requirement[1].get('assigned_to').baselineOne && userLookup[requirement[1].get('assigned_to').baselineOne.account_id]">
            {{ userLookup[requirement[1].get('assigned_to').baselineOne.account_id].displayName }}
          </span>
        </td>
        <td headers="baseline-two">
          <span v-if="requirement[1].get('assigned_to').baselineTwo && userLookup[requirement[1].get('assigned_to').baselineTwo.account_id]">
            {{ userLookup[requirement[1].get('assigned_to').baselineTwo.account_id].displayName }}
          </span>
        </td>
      </tr>
      <tr v-if="requirement[1].has('status')">
        <td headers="id">
        </td>
        <td headers="field">
          Status
        </td>
        <td headers="baseline-one">
          <span v-if="requirement[1].get('status').baselineOne">
            {{ statusMap.get(requirement[1].get('status').baselineOne.atlassian_status_id.toString()).name }}
          </span>
        </td>
        <td headers="baseline-two">
          <span v-if="requirement[1].get('status').baselineTwo">
            {{ statusMap.get(requirement[1].get('status').baselineTwo.atlassian_status_id.toString()).name }}
          </span>
        </td>
      </tr>
      <tr v-if="requirement[1].has('components')">
        <td headers="id">
        </td>
        <td headers="field">
          Components
        </td>
        <td headers="baseline-one">
          <div v-if="requirement[1].get('components').baselineOne">
            <span v-for="component in requirement[1].get('components').baselineOne">
            {{ componentMap.get(component.atlassian_component_id.toString()).name }}
            </span>
          </div>
        </td>
        <td headers="baseline-two">
          <div v-if="requirement[1].get('components').baselineTwo">
            <span v-for="component in requirement[1].get('components').baselineTwo">
            {{ componentMap.get(component.atlassian_component_id.toString()).name }}
            </span>
          </div>
        </td>
      </tr>
      <tr v-if="requirement[1].has('description')">
        <td headers="id">
        </td>
        <td headers="field">
          Description
        </td>
        <td headers="baseline-one">
          <b-form-textarea v-if="requirement[1].get('description').baselineOne"
                           plaintext
                           no-resize
                           :max-rows="6"
                           :value="requirement[1].get('description').baselineOne">
          </b-form-textarea>
        </td>
        <td headers="baseline-two">
          <b-form-textarea v-if="requirement[1].get('description').baselineTwo"
                           plaintext
                           no-resize
                           :max-rows="6"
                           :value="requirement[1].get('description').baselineTwo">
          </b-form-textarea>
        </td>
      </tr>
      <tr v-if="requirement[1].has('linked_requirements')">
        <td headers="id">
        </td>
        <td headers="field">
          Linked Requirements
        </td>
        <td headers="baseline-one">
          <span v-if="requirement[1].get('linked_requirements').baselineOne">
            <span v-for="reqOne in requirement[1].get('linked_requirements').baselineOne">
              <a href="#" @click="goToReq(reqOne.requirement_id)">{{ reqOne.requirement_type.prefix }}{{ reqOne.display_id ? reqOne.display_id : reqOne.requirement_id }}</a>&nbsp;
            </span>
          </span>
        </td>
        <td headers="baseline-two">
          <span v-if="requirement[1].get('linked_requirements').baselineTwo">
            <span v-for="reqTwo in requirement[1].get('linked_requirements').baselineTwo">
              <a href="#" @click="goToReq(reqTwo.requirement_id)">{{ reqTwo.requirement_type.prefix }}{{ reqTwo.display_id ? reqTwo.display_id : reqTwo.requirement_id }}</a>&nbsp;
            </span>
          </span>
        </td>
      </tr>
      <tr v-if="requirement[1].has('issues') && Object.keys(issueLookup).length > 0">
        <td headers="id">
        </td>
        <td headers="field">
          Linked Issues
        </td>
        <td headers="baseline-one">
          <div v-if="requirement[1].get('issues').baselineOne">
          <span v-for="issue in requirement[1].get('issues').baselineOne">
            <a target="_blank" :href="`${$auth.user().atlassian_base_url}/browse/${issueLookup[issue.atlassian_issue_id.toString()].key}`">{{ issueLookup[issue.atlassian_issue_id.toString()].key }}</a>&nbsp;
          </span>
          </div>
        </td>
        <td headers="baseline-two">
          <div v-if="requirement[1].get('issues').baselineTwo">
          <span v-for="issue in requirement[1].get('issues').baselineTwo">
            <a target="_blank" :href="`${$auth.user().atlassian_base_url}/browse/${issueLookup[issue.atlassian_issue_id.toString()].key}`">{{ issueLookup[issue.atlassian_issue_id.toString()].key }}</a>&nbsp;
          </span>
          </div>
        </td>
      </tr>
      <tr v-if="requirement[1].has('contents')">
        <td headers="id">
        </td>
        <td headers="field">
          Linked Confluence Content
        </td>
        <td headers="baseline-one">
          <div v-if="requirement[1].get('contents').baselineOne">
          <span v-for="content in requirement[1].get('contents').baselineOne">
            {{ content.atlassian_content_id }}
          </span>
          </div>
        </td>
        <td headers="baseline-two">
          <div v-if="requirement[1].get('contents').baselineTwo">
          <span v-for="content in requirement[1].get('contents').baselineTwo">
            {{ content.atlassian_content_id }}
          </span>
          </div>
        </td>
      </tr>
      <tr v-if="requirement[1].has('attachments')">
        <td headers="id">
        </td>
        <td headers="field">
          Attachments
        </td>
        <td headers="baseline-one">
          <div v-if="requirement[1].get('attachments').baselineOne">
          <span v-for="attachment in requirement[1].get('attachments').baselineOne">
            {{ attachment.original_file_name }}
          </span>
          </div>
        </td>
        <td headers="baseline-two">
          <div v-if="requirement[1].get('attachments').baselineTwo">
          <span v-for="attachment in requirement[1].get('attachments').baselineTwo">
            {{ attachment.original_file_name }}
          </span>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  import getDataFromAtlassianMixin from '@/mixins/getDataFromAtlassian'
  import utilsMixin from '@/mixins/utils'
  export default {
    computed: {
      currentProject () {
        return this.$store.state.currentProject
      }
    },
    data () {
      return {
        userLookup: {},
        displayIdLookup: {},
        userAccountIdsToQuery: new Set(),
        baselinesArray: [],
        baselines: [],
        combinedRequirementLookup: {},
        componentMap: new Map(),
        diffLookup: new Map(),
        hasResults: false,
        issueLookup: {},
        loading: false,
        reporter: null,
        requirementTypeLookup: {},
        requirementTypeLookupReady: false,
        selectedBaselinesLite: {baselineOne: null, baselineTwo: null},
        selectedBaselines: {baselineOne: null, baselineTwo: null},
        statusMap: new Map()
      }
    },
    mixins: [getDataFromAtlassianMixin, utilsMixin],
    methods: {
      combineIssues () {
        let issueArray = []
        // Combine all issues from requirements to get all the IDs, to make a single request to Atlassian
        for (let baseline of [this.selectedBaselines.baselineOne, this.selectedBaselines.baselineTwo]) {
          for (let reqRev of baseline.requirement_revisions) {
            for (let iss of reqRev.issues) {
              issueArray.push(iss.atlassian_issue_id)
            }
          }
        }
        // This is some new ES6 ish that creates a set from an array
        this.combinedIssues = [...new Set(issueArray)]
        this.getIssueDataFromAtlassian()
      },
      getDisplayID (requirementId) {
        if (requirementId in this.displayIdLookup && this.displayIdLookup[requirementId] !== null) {
          return this.displayIdLookup[requirementId]
        } else {
          return requirementId
        }
      },
      getDisplayIds () {
        this.$http.post(
          '/api/requirement/display_ids',
          {
            'requirementIds': Array.from(this.diffLookup.keys())
          }
        ).then(response => {
          console.log(response.data)
          this.displayIdLookup = response.data
        }, response => {
          console.log('error')
        })
      },
      getAssigneeDataFromAtlassian () {
        this.userAccountIdsToQuery.forEach(accountId => {
          window.AP.request({
            url: `/rest/api/3/user?accountId=${accountId}`,
            success: response => {
              // convert the string response to JSON
              response = JSON.parse(response)
              // This little hack is to make the Vue top level object attribute reactive (the change registers in the app)
              this.$set(this.userLookup, accountId, response)
            },
            error: () => {
              console.log(arguments)
            }
          })
        })
      },
      getCombinedRequirementLookup () {
        // Iterate over each baseline, creating a lookup object that has the issues/attributes for each req for each baseline
        let combinedRequirementLookup = new Map()
        for (let reqRev of this.selectedBaselines.baselineOne.requirement_revisions) {
          if (combinedRequirementLookup.has(reqRev.requirement_id)) {
            combinedRequirementLookup.get(reqRev.requirement_id).baselineOne = reqRev
          } else {
            combinedRequirementLookup.set(reqRev.requirement_id, {baselineOne: reqRev, baselineTwo: null})
          }
        }
        // Now iterate over the second baseline
        for (let reqRev of this.selectedBaselines.baselineTwo.requirement_revisions) {
          if (combinedRequirementLookup.has(reqRev.requirement_id)) {
            combinedRequirementLookup.get(reqRev.requirement_id).baselineTwo = reqRev
          } else {
            combinedRequirementLookup.set(reqRev.requirement_id, {baselineOne: null, baselineTwo: reqRev})
          }
        }
        // Now create the final lookup
        let fields = ['assigned_to', 'components', 'description', 'issues', 'name', 'status',
          'contents', 'requirement_type_id', 'linked_requirements', 'attachments']
        this.diffLookup = new Map()
        for (let req of combinedRequirementLookup) {
          let currentMap = new Map()
          for (let field of fields) {
            let baselineOne = req[1].baselineOne ? req[1].baselineOne[field] : null
            let baselineTwo = req[1].baselineTwo ? req[1].baselineTwo[field] : null
            // Build up the set of assignees to then query Atlassian for
            if (field === 'assigned_to') {
              for (let bl of [baselineOne, baselineTwo]) {
                if (bl) {
                  this.userAccountIdsToQuery.add(bl.account_id)
                }
              }
            }
            if (!this.$lodash.isEqual(baselineOne, baselineTwo)) {
              if ((!Array.isArray(baselineOne) && baselineOne) || (!Array.isArray(baselineTwo) && baselineTwo) || (Array.isArray(baselineOne) && baselineOne.length > 0) || (Array.isArray(baselineTwo) && baselineTwo.length > 0)) {
                currentMap.set(field,
                  {
                    baselineOne: baselineOne,
                    baselineTwo: baselineTwo
                  })
              }
            }
          }
          this.diffLookup.set(req[0], currentMap)
        }
        this.getAssigneeDataFromAtlassian()
        this.getDisplayIds()
      },
      getComponents () {
        window.AP.request({
          url: `/rest/api/3/project/${this.currentProject.id}/components`,
          success: response => {
            // convert the string response to JSON
            response = JSON.parse(response)
            for (let component of response) {
              this.componentMap.set(component.id, component)
            }
          },
          error: () => {
            console.log(arguments)
          }
        })
      },
      getBaseline (baselineObj) {
        const baselineId = baselineObj[0]
        const objKey = baselineObj[1]
        return this.$http.get(
          `/api/baseline/${baselineId}?atlassian_project_id=${this.currentProject.id}`
        ).then(response => {
          this.selectedBaselines[objKey] = response.data.baseline
        }, response => {
          console.log('error')
        })
      },
      getBaselines () {
        this.$http.get(
          '/api/baseline?atlassian_project_id=' + this.currentProject.id
        ).then(response => {
          this.baselinesArray = response.data.baselines.map(i => {
            return {'text': i.name, 'value': i}
          })
          this.baselines = response.data.baselines
        }, response => {
          console.log('error')
        })
      },
      getIssueDataFromAtlassian () {
        if (this.combinedIssues.length > 0) {
          this.getIssueDataFromAtlassianPaginated(this.combinedIssues, null, 50)
        }
      },
      goToReq (requirementId) {
        window.AP.history.pushState(`${this.currentProject.id}-requirements-${requirementId}`)
      },
      onSubmit (e) {
        e.preventDefault()
        this.loading = true
        this.hasResults = false
        this.combinedRequirementLookup = new Map()
        this.userAccountIdsToQuery = new Set()
        this.userLookup = {}
        // This completes both async tasks, then afterwords runs the stuff in .then
        const arr = [ [this.selectedBaselinesLite.baselineOne.baseline_id, 'baselineOne'], [this.selectedBaselinesLite.baselineTwo.baseline_id, 'baselineTwo'] ]

        Promise.all(arr.map(this.getBaseline)).then(results => {
          this.combineIssues()
          this.getAssigneeDataFromAtlassian()
          this.getCombinedRequirementLookup()
          this.hasResults = true
          this.loading = false
        })
      },
      setIssues (response, readyToRender) {
        for (let iss of response.issues) {
          this.$set(this.issueLookup, iss.id, iss)
        }
      },
      setStatusOptions (response) {
        // combine the arrays inside the 'statuses' values for each obj
        const fullList = [].concat(...response.map(issueType => issueType.statuses))
        // Add to Map
        for (let status of fullList) {
          this.statusMap.set(status.id, status)
        }
      },
      getRequirementTypes () {
        this.$http.get(
          '/api/requirement/type'
        ).then(response => {
          for (let requirementType of response.data.requirement_types) {
            this.requirementTypeLookup[requirementType.requirement_type_id] = requirementType
          }
          this.requirementTypeLookupReady = true
        }, error => {
          let errorString = this.createErrorStringFromResponse(error.response.data)
          window.AP.flag.create({
            title: 'Error',
            body: `There was a problem retrieving your requirement types: ${errorString}`,
            type: 'error'
          })
        })
      }
    },
    mounted () {
      this.getBaselines()
      this.getRequirementTypes()
      // Todo - move these next two into getBaselines()?
      this.getComponents()
      this.getStatusesForCurrentProject()
    },
    watch: {
      currentProject (currentValue) {
        if (this.currentProject) {
          this.hasResults = false
          this.selectedBaselines = {baselineOne: null, baselineTwo: null}
          this.getBaselines()
          // Todo - move these next two into getBaselines()?
          this.getComponents()
          this.getStatusesForCurrentProject()
        }
      }
    }
  }
</script>

<style>
  .baseline-select-label {
    margin: 0 15px;
  }
</style>



// WEBPACK FOOTER //
// BaselineComparison.vue?d5b59cae